module.exports = {"single":"single-app-384097.js"}


/** WEBPACK FOOTER **
 ** ./Scripts/aem/app.js
 **/